import TechStackGroup from "./TechStackGroup";

const TechStackLeftSummary = ({
  profileSummaries,
  siteTheme,
  techStacks,
  isDay,
}) => {
  return (
    <div className="max-w-max-profile-content-width mx-auto px-2 md:px-0">
      <div className="flex flex-col w-full gap-10 mt-20 lg:flex-row lg:items-start">
        <div className="order-2 lg:order-1 w-full lg:pl-0 overflow-hidden lg:w-[70%] px-0 md:px-5">
          <div className="relative flex items-center justify-start w-full">
            <div className="w-1/2 sm:w-2/3 md::w-1/3 flex-nowrap">
              <p
                className={`${siteTheme.textColor} text-[10px] tracking-[0.1em] uppercase font-semibold font-saira`}
              >
                Techstack Summary
              </p>
            </div>
            <div
              className={`w-1/2 sm:w-3/4 md:w-2/3 h-[0.5px] bg-gradient-to-r from-linesLight to-transparent absolute right-0`}
            />
          </div>
          <div className="mt-10 lg:ml-10">
            <p
              className={`${
                isDay ? siteTheme.textColor : "text-neutral-400"
              } font-light text-[14px] tracking-[0.08em] leading-loose mb-10 font-saira`}
            >
              {profileSummaries.second}
            </p>
          </div>
        </div>
        <div className="order-1 lg:order-2 flex flex-col items-center justify-center float-right">
          <TechStackGroup data={techStacks.slice(10, 12)} />
          <TechStackGroup data={techStacks.slice(12, 15)} />
          <TechStackGroup data={techStacks.slice(15, 17)} />
          <TechStackGroup data={techStacks.slice(17, 20)} />
        </div>
      </div>
      <div className="w-full px-0 md:px-5 lg:px-0 overflow-hidden md:mt-10">
        <p
          className={`${
            isDay ? siteTheme.textColor : "text-neutral-400"
          } font-light text-[14px] tracking-[0.08em] leading-loose mb-10 font-saira`}
        >
          {profileSummaries.sixth}
        </p>
        <p
          className={`${
            isDay ? siteTheme.textColor : "text-neutral-400"
          } font-light text-[14px] tracking-[0.08em] leading-loose mb-10 font-saira`}
        >
          {profileSummaries.fifth}
        </p>
        <p
          className={`${
            isDay ? siteTheme.textColor : "text-neutral-400"
          } font-light text-[14px] tracking-[0.08em] leading-loose mb-10 font-saira`}
        >
          {profileSummaries.seventh}
        </p>
      </div>
    </div>
  );
};

export { TechStackLeftSummary };
export default TechStackLeftSummary;
